import React from 'react'
import { Grid } from '@mui/material_modern'
import { useGetAssetsByCategoryQuery } from 'services/physicalAssets'
import { formatAssetForGrid } from 'components/containers/load-board/utils/formatFunctions'
import { ASSET_CATEGORY } from 'utils/constants'
import TrailerAssetsGrid from 'components/generic/datagrid/TrailerAssetsGrid/index'

const TrailerAssetsContainer = () => {
  const { data: trailerAssetData, isLoading: isLoadingContainerData } = useGetAssetsByCategoryQuery({
    assetCategory: ASSET_CATEGORY.TRAILER,
  })

  const transformedRows = (trailerAssetData?.Items || []).slice().map(asset => formatAssetForGrid(asset))

  return (
    <>
      <Grid p={3} sx={{ height: '100%' }} container flexDirection="column">
        <TrailerAssetsGrid rows={transformedRows} loading={isLoadingContainerData} />
      </Grid>
    </>
  )
}

export default TrailerAssetsContainer
